export const PauseOutline = (props) => (
  <svg
    width='34'
    height='34'
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...props?.style }}
  >
    <rect x='0.5' y='0.5' width='33' height='33' rx='16.5' stroke='#FCAF17' />
    <circle cx='17.0003' cy='16.9998' r='13.3333' fill='#FCAF17' />
    <path
      d='M18.3333 11.6668C18.3333 10.9305 18.9303 10.3335 19.6667 10.3335C20.403 10.3335 21 10.9304 21 11.6668V22.3335C21 23.0699 20.403 23.6668 19.6667 23.6668C18.9303 23.6668 18.3333 23.0699 18.3333 22.3335V11.6668Z'
      fill='white'
    />
    <path
      d='M13 11.6668C13 10.9305 13.597 10.3335 14.3333 10.3335C15.0697 10.3335 15.6667 10.9304 15.6667 11.6668V22.3335C15.6667 23.0699 15.0697 23.6668 14.3333 23.6668C13.597 23.6668 13 23.0699 13 22.3335V11.6668Z'
      fill='white'
    />
  </svg>
);
